import { useInfiniteQuery } from 'react-query';

import { lovageApi } from '../../axios';
import { snakeify } from '../../utils/formatObjKeys';
import { fDate } from '../../utils/formatTime';
import type { Voicemail } from './useVoicemail';
const qs = require('qs');

export type { Voicemail } from './useVoicemail';

export interface VoicemailList {
  items: Voicemail[];
  total: number;
  limit: number;
  offset: number;
}

export interface VoicemailListRequest {
  locationIds: number[] | undefined;
  limit: number;
  startDate: Date;
  endDate: Date;
  offset: number;
  timezone: string;
}

interface VoicemailListArg {
  request: Omit<VoicemailListRequest, 'offset'>;
}

export const fetchVoicemailList = (request: VoicemailListRequest) => {
  console.log('fetchVoicemailList');

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { location_ids, ...snakeifiedRequest } = snakeify(request);

  // Change locationIds to location_id
  let finalRequest = {
    ...snakeifiedRequest,
    location_id: request.locationIds,
  };

  return lovageApi
    .get<VoicemailList>(`/dashboard/voicemail`, {
      params: finalRequest,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    .then((res) => res.data);
};

export default function useVoicemailList({ request }: VoicemailListArg) {
  const { locationIds, startDate, endDate } = request;

  const queryKey = [
    'voicemailList',
    locationIds,
    { startDate: fDate(startDate), endDate: fDate(endDate) }, // fDate gets just the month, day, and year so React Query doesn't invalidate the cache for identical dates
  ];

  return useInfiniteQuery(
    queryKey,
    ({ pageParam = 0 }) =>
      fetchVoicemailList({
        ...request,
        offset: pageParam,
      }),
    {
      getNextPageParam: (lastPageData, _pages) => {
        const lastPageItems = lastPageData?.items;

        if (!lastPageItems) {
          return undefined;
        }

        if (lastPageItems.length === 0) {
          return undefined;
        }

        const { total, offset, limit } = lastPageData;
        const nextOffset = offset + limit;

        if (offset + lastPageItems.length < total) {
          return nextOffset;
        }

        return undefined;
      },
      refetchOnWindowFocus: process.env.NODE_ENV === 'production',
    }
  );
}
